import template from './addInput.html';
import controller from './addInput.controller';
import './addInput.scss';

let addInputComponent = {
  restrict: 'E',
  bindings: {
    label: '@',
    add: '&'
  },
  template,
  controller
};

export default addInputComponent;
